<template>
  <div>
    <header-bar></header-bar>

    <section class="admin bump-header">
      <div class="grid-container">

        <div class="row">

          <div class="col-6">
            <h1>No of Users:</h1>
            <div>{{ noOfUsers }}</div>
          </div>

          <div class="col-6">
            <h1>No of Users ONLINE:</h1>
            <div>{{ onlineUsers }}</div>
          </div>

        </div>

      </div>
    </section>

  </div>
</template>

<script>
import { db } from '@/firebase'
import HeaderBar from '@/components/HeaderBar'

export default {
  name: 'Admin',
  components: {
    HeaderBar
  },
  data () {
    return {
    }
  },
  firebase: function () {
    return {
      users: {
        source: db.ref('users')
      },
      presence: {
        source: db.ref('presence').orderByValue().equalTo(true)
      }
    }
  },
  computed: {
    noOfUsers: function () {
      if (this.users) {
        return this.users.length
      }
    },
    onlineUsers: function () {
      if (this.presence) {
        return this.presence.length
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Overview.vue?5c468c6d